// Mensagens de erro do e-commerce podem chegar corrompidas da API Chleba em alguns ambientes:
// o texto retornado já contém o caractere de substituição U+FFFD (exibido como "ï¿½"), sem
// possibilidade de recuperar o caractere original. Nesses casos exibimos uma mensagem genérica
// traduzida em vez do texto ilegível; quando a mensagem vem íntegra, mantemos o detalhe da API.
//
// Detecta U+FFFD e a sua forma re-decodificada como Latin-1 (U+00EF U+00BF U+00BD).
const REPLACEMENT_CHARS = /�|ï¿½/;

export default function getEcommerceErrorDescription(intl, error, fallbackId) {
  const code = error?.response?.data?.code || "unknown";
  const errorMessage = error?.response?.data?.errorMessage;

  if (errorMessage && REPLACEMENT_CHARS.test(errorMessage)) {
    return intl.formatMessage({ id: fallbackId });
  }

  return intl.formatMessage({ id: `api.error.${code}` }, { errors: errorMessage });
}
